import { render } from "./KvnEvent.vue?vue&type=template&id=72cae7b6&scoped=true"
import script from "./KvnEvent.vue?vue&type=script&lang=js"
export * from "./KvnEvent.vue?vue&type=script&lang=js"

import "./KvnEvent.vue?vue&type=style&index=0&id=72cae7b6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72cae7b6"]])

export default __exports__